import { tourist } from "../Icons/icons";
import { useEffect } from "react";
import useLeaflet from "../hooks/useLeaflet";

const L: any = require("leaflet");
L.esri = require("esri-leaflet");

const featureServerURL =
  "https://services-eu1.arcgis.com/1PSnmNDZsplHdhAh/arcgis/rest/services/Hav%C3%B8rred_Limfjorden___opdatering_af_kort_2023/FeatureServer/0";

/*
 * This component displays the tourist offices on the map
 */

const TouristOffices = (props) => {
  const context = useLeaflet();
  useEffect(() => {
    if (!context) return;
    const layer = L.esri.featureLayer({
      //pladser fra gis
      url: featureServerURL,
      pointToLayer(_feature, latlng) {
        const layer = new L.Marker(latlng, {
          icon: tourist,
          zIndexOffset: 50,
        });
        return layer;
      },
    });

    // layer.bindTooltip((layer) => {
    //   return layer.feature.properties.TURISTKONT;
    // });

    layer.addTo(context.map);

    layer.on("click", (e) => {
      props.onClick && props.onClick(e.layer.feature);
    });

    return () => {
      context.map.removeLayer(layer);
    };
  }, [props.language]);

  return null;
};

export default TouristOffices;
